import { LayoutGrid, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { PageHeader } from '@/components/common/PageHeader'
import { EmptyState, ErrorState } from '@/components/common/States'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { useAuth } from '@/lib/auth/AuthProvider'
import { useDashboardLayout } from './api'
import { WidgetGrid } from './components/WidgetGrid'

export const DASHBOARD_EDIT_PATH = '/ana-sayfa/duzenle'

export function DashboardPage() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const layout = useDashboardLayout()
  const today = new Intl.DateTimeFormat('tr-TR', { dateStyle: 'full' }).format(new Date())
  const widgets = layout.data?.widgets ?? []

  return (
    <>
      <PageHeader
        eyebrow={today}
        title={t('dashboard.greeting', { name: user?.first_name ?? '' })}
        description={t('dashboard.subtitle')}
        actions={
          <Button variant="outline" asChild>
            <Link to={DASHBOARD_EDIT_PATH}>
              <LayoutGrid />
              {t('dashboard.customize')}
            </Link>
          </Button>
        }
      />
      {layout.isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-26 rounded-2xl" />
          ))}
          <Skeleton className="h-80 rounded-2xl sm:col-span-2" />
          <Skeleton className="h-80 rounded-2xl sm:col-span-2" />
        </div>
      ) : layout.isError ? (
        <ErrorState error={layout.error} onRetry={() => void layout.refetch()} />
      ) : widgets.length === 0 ? (
        <EmptyState
          icon={LayoutGrid}
          title={t('dashboard.emptyLayout')}
          description={t('dashboard.emptyLayoutHint')}
          action={
            <Button size="sm" asChild>
              <Link to={DASHBOARD_EDIT_PATH}>
                <Plus />
                {t('dashboard.addWidgets')}
              </Link>
            </Button>
          }
        />
      ) : (
        <WidgetGrid widgets={widgets} />
      )}
    </>
  )
}
